module.exports = __webpack_public_path__ + "static/img/126_TO8_1674.2321206.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/126_TO8_1674.jpg
// module id = J2gz
// module chunks = 0